export enum UsageEventMetric {
    AnalyticsEvents = 'analytics.events',
    AnalyticsPageviews = 'analytics.pageviews',
    AnalyticsBotsEvents = 'analytics.bots.events',
    NetworkRequests = 'network.requests',
    NetworkInbound = 'network.inbound',
    NetworkOutbound = 'network.outbound',
    WebhooksEventsSent = 'webhooks.events.sent',
    WebhooksEventsFailed = 'webhooks.events.failed',
    AuthMethodPhone = 'auth.method.phone',
    MessagesSent = 'messages.sent',
    MessagesFailed = 'messages.failed',
    MessagesSmsSent = 'messages.sms.sent',
    Executions = 'executions',
    ExecutionsCompute = 'executions.compute',
    ExecutionsMbSeconds = 'executions.mbSeconds',
    FunctionsExecutions = 'functions.executions',
    SitesExecutions = 'sites.executions',
    FunctionsExecutionsCompute = 'functions.executions.compute',
    SitesExecutionsCompute = 'sites.executions.compute',
    FunctionsExecutionsMbSeconds = 'functions.executions.mbSeconds',
    SitesExecutionsMbSeconds = 'sites.executions.mbSeconds',
    Builds = 'builds',
    BuildsSuccess = 'builds.success',
    BuildsFailed = 'builds.failed',
    BuildsCompute = 'builds.compute',
    BuildsComputeSuccess = 'builds.compute.success',
    BuildsComputeFailed = 'builds.compute.failed',
    BuildsMbSeconds = 'builds.mbSeconds',
    FunctionsBuildsMbSeconds = 'functions.builds.mbSeconds',
    SitesBuildsMbSeconds = 'sites.builds.mbSeconds',
    DatabasesOperationsReads = 'databases.operations.reads',
    DatabasesOperationsWrites = 'databases.operations.writes',
    DocumentsdbDatabasesOperationsReads = 'documentsdb.databases.operations.reads',
    DocumentsdbDatabasesOperationsWrites = 'documentsdb.databases.operations.writes',
    VectorsdbDatabasesOperationsReads = 'vectorsdb.databases.operations.reads',
    VectorsdbDatabasesOperationsWrites = 'vectorsdb.databases.operations.writes',
    FilesImagesTransformed = 'files.imagesTransformed',
    AvatarsScreenshotsGenerated = 'avatars.screenshotsGenerated',
    RealtimeMessagesSent = 'realtime.messages.sent',
    RealtimeInbound = 'realtime.inbound',
    RealtimeOutbound = 'realtime.outbound',
    EmbeddingsText = 'embeddings.text',
    EmbeddingsTextTotalTokens = 'embeddings.text.totalTokens',
    EmbeddingsTextTotalDuration = 'embeddings.text.totalDuration',
    EmbeddingsTextTotalErrors = 'embeddings.text.totalErrors',
    WafRequestsDenied = 'waf.requests.denied',
    WafRequestsChallenged = 'waf.requests.challenged',
    WafRequestsRateLimited = 'waf.requests.rateLimited',
    WafRequestsRedirected = 'waf.requests.redirected',
    WafRequestsChallengeSolved = 'waf.requests.challengeSolved',
    WafChallengeSolveTimeMs = 'waf.challenge.solveTimeMs',
    AffiliatesClicks = 'affiliates.clicks',
    AffiliatesSignups = 'affiliates.signups',
    AffiliatesConversions = 'affiliates.conversions',
    DedicatedDatabasesInbound = 'dedicatedDatabases.inbound',
    DedicatedDatabasesOutbound = 'dedicatedDatabases.outbound',
    DedicatedDatabasesCompute = 'dedicatedDatabases.compute',
}
